class I18N {
  translations = {};

  constructor(translations) {
    this.translations = translations;
  }

  t(locale, key) {
    if (this.translations.hasOwnProperty(locale)) {
      if (this.translations[locale].hasOwnProperty(key)) {
        return this.translations[locale][key];
      } else {
        throw new Error(`Invalid translation key: ${key}`);
      }
    } else {
      throw new Error(`Invalid locale: ${locale}`);
    }
  }

}

export default I18N;
